import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Award, FlaskConical, ArrowRight } from 'lucide-react';
export function DoctorEndorsementSection() {
  return <Section background="cream" data-id="element-264">
      {/* Doctor quote block */}
      <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-265">
        {/* Content */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="order-2 md:order-1" data-id="element-266">
          <div className="inline-flex items-center gap-2 bg-[#2D5016]/10 text-[#2D5016] px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-6" data-id="element-267">
            <ShieldCheck className="w-4 h-4" data-id="element-268" />
            Respaldado por Profesionales
          </div>

          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6 leading-tight" data-id="element-269">
            La ciencia detrás de{' '}
            <span className="text-[#D4AF37]" data-id="element-270">cada parche</span>
          </h2>

          <blockquote className="border-l-4 border-[#D4AF37] pl-6 mb-8" data-id="element-271">
            <p className="text-lg text-gray-700 italic leading-relaxed mb-4" data-id="element-272">
              "La apiterapia transdérmica es una de las áreas más prometedoras
              de la medicina natural. El veneno de abeja contiene melitina y
              fosfolipasa A2, compuestos con propiedades antiinflamatorias y
              lipolíticas documentadas científicamente."
            </p>
            <footer className="text-sm font-bold text-gray-900" data-id="element-273">
              Dra. Elena Vargas
              <span className="font-normal text-gray-500 ml-2" data-id="element-274">
                — Especialista en Medicina Integrativa
              </span>
            </footer>
          </blockquote>

          <div className="grid grid-cols-3 gap-4 mb-8" data-id="element-275">
            <div className="text-center bg-white rounded-2xl p-4 shadow-sm border border-gray-100" data-id="element-276">
              <FlaskConical className="w-6 h-6 text-[#D4AF37] mx-auto mb-2" data-id="element-277" />
              <p className="text-xs font-bold text-gray-900" data-id="element-278">Fórmula</p>
              <p className="text-xs text-gray-500" data-id="element-279">Clínicamente probada</p>
            </div>
            <div className="text-center bg-white rounded-2xl p-4 shadow-sm border border-gray-100" data-id="element-280">
              <ShieldCheck className="w-6 h-6 text-[#D4AF37] mx-auto mb-2" data-id="element-281" />
              <p className="text-xs font-bold text-gray-900" data-id="element-282">100%</p>
              <p className="text-xs text-gray-500" data-id="element-283">Ingredientes naturales</p>
            </div>
            <div className="text-center bg-white rounded-2xl p-4 shadow-sm border border-gray-100" data-id="element-284">
              <Award className="w-6 h-6 text-[#D4AF37] mx-auto mb-2" data-id="element-285" />
              <p className="text-xs font-bold text-gray-900" data-id="element-286">Certificado</p>
              <p className="text-xs text-gray-500" data-id="element-287">Control de calidad</p>
            </div>
          </div>
        </motion.div>

        {/* Doctor image */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="order-1 md:order-2 relative" data-id="element-288">
          <div className="rounded-3xl overflow-hidden shadow-2xl" data-id="element-289">
            <img src="https://cdn.magicpatterns.com/uploads/w9VuMkVL8oJpN2zWAihugb/imgi_12_1754196072-ChatGPT_Image_Aug_22C_20252C_08_33_19_AM.png" alt="Doctora recomendando StingFit" className="w-full object-cover" data-id="element-290" />
          </div>
        </motion.div>
      </div>

      {/* Product lifestyle section */}
      <div className="bg-[#2D5016] rounded-3xl overflow-hidden" data-id="element-291">
        <div className="grid md:grid-cols-2 gap-0 items-center" data-id="element-292">
          <div className="p-8 md:p-12 order-2 md:order-1" data-id="element-293">
            <h3 className="text-2xl md:text-3xl font-extrabold text-white mb-4" data-id="element-294">
              Tan simple como ponerse{' '}
              <span className="text-[#D4AF37]" data-id="element-295">un parche</span>
            </h3>
            <p className="text-green-100 text-lg mb-6 leading-relaxed" data-id="element-296">
              Sin rutinas complicadas. Sin preparaciones. Sin interrumpir tu
              día. Aplica StingFit antes de dormir y despierta más cerca de tu
              objetivo.
            </p>
            <div className="space-y-3 mb-8" data-id="element-297">
              <div className="flex items-center gap-3 text-green-100" data-id="element-298">
                <span className="w-7 h-7 rounded-full bg-[#D4AF37] text-white text-xs font-black flex items-center justify-center flex-shrink-0" data-id="element-299">
                  1
                </span>
                <span data-id="element-300">Limpia y seca la zona abdominal</span>
              </div>
              <div className="flex items-center gap-3 text-green-100" data-id="element-301">
                <span className="w-7 h-7 rounded-full bg-[#D4AF37] text-white text-xs font-black flex items-center justify-center flex-shrink-0" data-id="element-302">
                  2
                </span>
                <span data-id="element-303">Aplica el parche cerca del ombligo</span>
              </div>
              <div className="flex items-center gap-3 text-green-100" data-id="element-304">
                <span className="w-7 h-7 rounded-full bg-[#D4AF37] text-white text-xs font-black flex items-center justify-center flex-shrink-0" data-id="element-305">
                  3
                </span>
                <span data-id="element-306">Duerme 8 horas y retíralo por la mañana</span>
              </div>
            </div>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-[#2D5016] transition-all font-bold group" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-307">
              <span className="flex items-center" data-id="element-308">
                EMPEZAR AHORA
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-309" />
              </span>
            </Button>
            <p className="text-xs text-green-300 font-bold mt-3" data-id="element-310">
              💰 Pago contra entrega en la puerta de tu casa
            </p>
          </div>
          <div className="order-1 md:order-2" data-id="element-311">
            <img src="https://cdn.magicpatterns.com/uploads/kxHfSSYXhS37bb1synnuJK/imgi_13_1754196552-ChatGPT_Image_Aug_32C_20252C_06_44_01_AM.png" alt="StingFit - Parche de veneno de abeja con accesorios de fitness" className="w-full h-full object-cover" data-id="element-312" />
          </div>
        </div>
      </div>
    </Section>;
}